import { render, staticRenderFns } from "./SsidPolicy.vue?vue&type=template&id=2c05e2d5&"
import script from "./SsidPolicy.vue?vue&type=script&lang=js&"
export * from "./SsidPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports